<template>
  <Menu
    v-if="$store.state.data.notifications?.results?.filter((n) => n.status == 'unseen').length > 0"
    v-slot="{ close }"
    as="div"
    :class="[{ 'ml-auto': $store.state.auth.user.user_type == 'end_user' }]"
    class="relative px-3 mt-2 -ml-1 text-left right-2">
    <MenuButton>
      <BellRing
        v-if="$store.state.data.notifications?.results?.filter((n) => n.status == 'unseen').length > 0"
        :fill="$store.state.ui_options.theme?.button_color"
        :color="$store.state.ui_options.theme?.button_color"
        class="w-5 h-5" />
      <Bell v-else fill="#A0AEC0" color="#A0AEC0" class="w-5 h-5" />
    </MenuButton>

    <!-- Sidebar user menu -->
    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0">
      <!-- mx wil have to be adjusted on the "closed" variant to align with where the user picture is -->
      <MenuItems
        v-if="$store.state.data.notifications?.results?.length > 0"
        ref="notificationsScrollContainer"
        v-debounce-scroll="handleScrollNotifications"
        class="absolute z-10 bg-white rounded-md shadow-dark-box right-8 w-[500px] max-h-80 h-80 overflow-y-auto">
        <div class="sticky top-0 z-10 flex flex-col items-center justify-start w-full gap-4 pt-2 pl-2 bg-white">
          <div class="flex items-center justify-between w-full h-10 text-xl font-medium leading-normal text-gray-700">
            {{ $t("Notifications") }}
            <div
              v-if="$store.state.data.notifications?.results?.filter((n) => n.status == 'unseen').length"
              class="p-2 text-sm font-medium leading-normal text-right cursor-pointer grow shrink basis-0 text-sky-500"
              @click="handleMarkAllAsSeen(close)">
              {{ $t("Mark all as read") }}
            </div>
          </div>
          <div class="w-full border border-gray-100 border-1.5" />
        </div>

        <MenuItem
          v-for="notification in $store.state.data.notifications.results"
          :key="notification.id"
          as="div"
          class="inline-flex items-center justify-start w-full p-3 px-3 mt-4 cursor-pointer hover:bg-gray-100"
          @click="executeNotificationAction(notification)">
          <div :class="{ 'opacity-0': notification.status == 'seen' }" class="flex-shrink-0 w-3 h-3 mr-1 rounded-full bg-blue" />
          <span class="flex items-center justify-between flex-shrink-0 w-12">
            <span class="flex items-center justify-between min-w-0 space-x-3">
              <span v-if="$store.state.data.users.find((u) => u.id == notification.action_performer)?.avatar" class="relative">
                <img
                  onerror="this.onerror=null; this.src=window.default_avatar;"
                  class="inline-block w-10 h-10 rounded-full"
                  :src="$store.state.data.users.find((u) => u.id == notification.action_performer).avatar"
                  alt="">
              </span>
              <span v-else class="relative">
                <Avatar
                  :first-name="$store.state.data.users.find((u) => u.id == notification.action_performer)?.first_name"
                  :last-name="$store.state.data.users.find((u) => u.id == notification.action_performer)?.last_name"
                  :radius="38" />
              </span>
            </span>
          </span>
          <div class="relative flex flex-col items-start justify-start">
            <div class="w-full" :class="{ 'font-bold': notification.status == 'unseen' }">
              {{ notification.description }}
            </div>
            <div class="w-full text-xs font-normal leading-normal text-right text-neutral-400">
              {{ $moment(notification.datetime_created).fromNow() }}
            </div>
          </div>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script>
import { Bell, BellRing } from "lucide-vue-next"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
import Avatar from "@/components/shared/Avatar.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import { event as google_event } from "vue-gtag-next"

export default {
  components: {
    Avatar,
    Bell,
    BellRing,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems
  },
  created() {
    if (this.$route.query?.otype) {
      this.executeNotificationAction({
        [this.$route.query?.otype]: this.$route.query?.id
      })
    }
  },
  methods: {
    executeNotificationAction(notification) {
      this.$store.dispatch("data/markNotificationAsSeen", {
        user_id: this.$store.state.auth.user.id,
        notification_id: notification.id
      })
      if (notification.interaction) {
        this.$emitter.emit(ALL_EMITTERS.UPDATE_INTERACTION, {
          interaction: { id: notification.interaction }
        })
      } else if (notification.goal) {
        this.$emitter.emit(ALL_EMITTERS.UPDATE_GOAL, {
          goal: { id: notification.goal }
        })
      } else if (notification.plan) {
        this.$emitter.emit(ALL_EMITTERS.UPDATE_PLAN, {
          plan: { id: notification.plan }
        })
      } else if (notification.task) {
        this.$emitter.emit(ALL_EMITTERS.UPDATE_TASK, {
          task: { id: notification.task }
        })
      } else {
        this.$router.push(notification.associated_link.replace(/^https?:\/\/[^/]+(\/.*)$/, "$1"))
      }
    },
    handleMarkAllAsSeen(close) {
      this.$store.dispatch("data/markAllNotificationAsSeen", {
        user_id: this.$store.state.auth.user.id
      })
      if (close) {
        close()
      }
      this.$toast.open({
        message: this.$t("All notifications marked as read"),
        position: "top",
        type: "success",
        duration: 3000
      })
      google_event("mark_all_as_read_notifications_click", {
        user_name: this.$store.state.auth.user.full_name,
        user_email: this.$store.state.auth.user.email,
        organization: this.$store.state.organization.name
      })
    },
    handleScrollNotifications() {
      return this.$store.dispatch("getMoreNotifications")
    }
  }
}
</script>
